import React from "react";
import { Home, Bot, Ticket, HelpCircle, Megaphone, Map,MessagesSquare, MessageSquare } from "lucide-react";
import "../CSS/Footer.css";

function Footer({
  view,
  setView,
  activeIcon,
  setActiveIcon,
  setupDetails,
  widgetConfigs,
  setIsExpanded,
  setSelectedArticle,
  tabUnreadCounts,
  setTabUnreadCounts,
}) {

  const navigateTo = (targetView, targetIcon) => {
    if (setIsExpanded) setIsExpanded(false);
    if (setSelectedArticle) setSelectedArticle(null);
    if (targetIcon === "ai" && setTabUnreadCounts) {
      setTabUnreadCounts((prev) => ({ ...prev, ai: 0, messages: 0 }));
    }
    if (targetIcon === "tickets" && setTabUnreadCounts) {
      setTabUnreadCounts((prev) => ({ ...prev, tickets: 0 }));
    }
    setActiveIcon(targetIcon);
    setView(targetView);
  };

  const uiColor =
    setupDetails?.widgetCustomizations?.uiColor ||
    setupDetails?.widgetCustomizations?.color1 ||
    setupDetails?.widgetCustomizations?.primaryColor ||
    "#1C243A";

  const showNav =
    view !== "LiveChat" &&
    view !== "message" &&
    view !== "MessageDetails";

  if (!showNav) return null;

  return (
    <div className="absolute bottom-3 left-3 right-3 z-50 pointer-events-none flex justify-center">
      <div
        className="w-full rounded-full px-2 py-1.5 flex items-center justify-around transition-all duration-300 pointer-events-auto border border-white/40 shadow-xl"
        style={{
          background:
            "linear-gradient(180deg, rgba(255, 255, 255, 0.45) 0%, rgba(255, 255, 255, 0.22) 100%)",
          backdropFilter: "blur(24px) saturate(200%) contrast(105%)",
          WebkitBackdropFilter: "blur(24px) saturate(200%) contrast(105%)",
          boxShadow:
            "0 12px 36px -4px rgba(0, 0, 0, 0.22), 0 4px 12px -2px rgba(0, 0, 0, 0.12), inset 0 1px 1px 0 rgba(255, 255, 255, 0.65), inset 0 -1px 1px 0 rgba(0, 0, 0, 0.08)",
        }}
      >
        {setupDetails?.widgetCustomizations?.home !== false && (
          <button
            onClick={() => {
              navigateTo("LandingWindow", "home");
            }}
            className="flex flex-col items-center justify-center flex-1 py-1 px-1 rounded-full transition-all duration-200 border-none outline-none cursor-pointer bg-transparent"
          >
            <Home
              className={`w-5 h-5 mb-0.5 transition-all duration-200 ${
                activeIcon === "home"
                  ? "fill-none stroke-[2.5]"
                  : "fill-none text-slate-800 hover:text-black stroke-[2.2]"
              }`}
              style={activeIcon === "home" ? { color: uiColor } : {}}
            />
            <span
              className={`text-[10px] leading-tight transition-all duration-200 ${
                activeIcon === "home" ? "font-bold" : "font-semibold text-slate-800 hover:text-black"
              }`}
              style={activeIcon === "home" ? { color: uiColor } : {}}
            >
              Home
            </span>
          </button>
        )}

        {/* Unified Chat Tab - automatically adapts between Dexy AI, Legacy Chatbot, or Builder Workflow */}
        {(setupDetails?.widgetCustomizations?.aiBot !== false ||setupDetails?.widgetCustomizations?.conversation !== false)  && (() => {
          const isLegacy = setupDetails?.widgetWorkflow?.workflowId === 'legacy';
          const targetView = isLegacy ? "DexyAI" : "DexyAI";
          const tabLabel = "Messages";
          const unreadTotal = (tabUnreadCounts?.ai || 0) + (tabUnreadCounts?.messages || 0);

          return (
            <button
              onClick={() => {
                navigateTo(targetView, "ai");
              }}
              className="flex flex-col items-center justify-center flex-1 py-1 px-1 rounded-full transition-all duration-200 border-none outline-none cursor-pointer bg-transparent relative"
            >
              <div className="relative inline-flex items-center justify-center">
                <MessageSquare
                  className={`w-5 h-5 mb-0.5 transition-all duration-200 ${
                    activeIcon === "ai"
                      ? "fill-none stroke-[2.5]"
                      : "fill-none text-slate-800 hover:text-black stroke-[2.2]"
                  }`}
                  style={activeIcon === "ai" ? { color: uiColor } : {}}
                />
                {unreadTotal > 0 && (
                  <span className="dexkor-unread-badge absolute -top-1.5 -right-2.5 min-w-[16px] h-[16px] px-1 bg-[#ef4444] text-white text-[9px] font-bold rounded-full flex items-center justify-center border border-white shadow-sm pointer-events-none">
                    {unreadTotal > 3 ? " " : unreadTotal}
                  </span>
                )}
              </div>
              <span
                className={`text-[10px] leading-tight transition-all duration-200 ${
                  activeIcon === "ai" ? "font-bold" : "font-semibold text-slate-800 hover:text-black"
                }`}
                style={activeIcon === "ai" ? { color: uiColor } : {}}
              >
                {tabLabel}
              </span>
            </button>
          );
        })()}

        {setupDetails?.widgetCustomizations?.ticket !== false && (
          <button
            onClick={() => {
              navigateTo("chatList", "tickets");
            }}
            className="flex flex-col items-center justify-center flex-1 py-1 px-1 rounded-full transition-all duration-200 border-none outline-none cursor-pointer bg-transparent relative"
          >
            <div className="relative inline-flex items-center justify-center">
              <Ticket
                className={`w-5 h-5 mb-0.5 transition-all duration-200 ${
                  activeIcon === "tickets"
                    ? "fill-none stroke-[2.5]"
                    : "fill-none text-slate-800 hover:text-black stroke-[2.2]"
                }`}
                style={activeIcon === "tickets" ? { color: uiColor } : {}}
              />
              {tabUnreadCounts?.tickets > 0 && (
                <span className="dexkor-unread-badge absolute -top-1.5 -right-2.5 min-w-[16px] h-[16px] px-1 bg-[#ef4444] text-white text-[9px] font-bold rounded-full flex items-center justify-center border border-white shadow-sm pointer-events-none">
                  {tabUnreadCounts.tickets > 3 ? "4+" : tabUnreadCounts.tickets}
                </span>
              )}
            </div>
            <span
              className={`text-[10px] leading-tight transition-all duration-200 ${
                activeIcon === "tickets" ? "font-bold" : "font-semibold text-slate-800 hover:text-black"
              }`}
              style={activeIcon === "tickets" ? { color: uiColor } : {}}
            >
              Tickets
            </span>
          </button>
        )}

        {Boolean(setupDetails?.widgetCustomizations?.news) && (
          <button
            onClick={() => {
              navigateTo("News", "news");
            }}
            className="flex flex-col items-center justify-center flex-1 py-1 px-1 rounded-full transition-all duration-200 border-none outline-none cursor-pointer bg-transparent"
          >
            <Megaphone
              className={`w-5 h-5 mb-0.5 transition-all duration-200 ${
                activeIcon === "news"
                  ? "stroke-[2.5]"
                  : "text-slate-800 hover:text-black stroke-[2.2]"
              }`}
              style={activeIcon === "news" ? { color: uiColor } : {}}
            />
            <span
              className={`text-[10px] leading-tight transition-all duration-200 ${
                activeIcon === "news" ? "font-bold" : "font-semibold text-slate-800 hover:text-black"
              }`}
              style={activeIcon === "news" ? { color: uiColor } : {}}
            >
              News
            </span>
          </button>
        )}

        {Boolean(setupDetails?.widgetCustomizations?.roadmap) && (
          <button
            onClick={() => {
              navigateTo("Roadmap", "roadmap");
            }}
            className="flex flex-col items-center justify-center flex-1 py-1 px-1 rounded-full transition-all duration-200 border-none outline-none cursor-pointer bg-transparent"
          >
            <Map
              className={`w-5 h-5 mb-0.5 transition-all duration-200 ${
                activeIcon === "roadmap"
                  ? "stroke-[2.5]"
                  : "text-slate-800 hover:text-black stroke-[2.2]"
              }`}
              style={activeIcon === "roadmap" ? { color: uiColor } : {}}
            />
            <span
              className={`text-[10px] leading-tight transition-all duration-200 ${
                activeIcon === "roadmap" ? "font-bold" : "font-semibold text-slate-800 hover:text-black"
              }`}
              style={activeIcon === "roadmap" ? { color: uiColor } : {}}
            >
              Roadmap
            </span>
          </button>
        )}

        {Boolean(setupDetails?.widgetCustomizations?.help) && (
          <button
            onClick={() => {
              navigateTo("Help", "help");
            }}
            className="flex flex-col items-center justify-center flex-1 py-1 px-1 rounded-full transition-all duration-200 border-none outline-none cursor-pointer bg-transparent"
          >
            <HelpCircle
              className={`w-5 h-5 mb-0.5 transition-all duration-200 ${
                activeIcon === "help"
                  ? "stroke-[2.5]"
                  : "text-slate-800 hover:text-black stroke-[2.2]"
              }`}
              style={activeIcon === "help" ? { color: uiColor } : {}}
            />
            <span
              className={`text-[10px] leading-tight transition-all duration-200 ${
                activeIcon === "help" ? "font-bold" : "font-semibold text-slate-800 hover:text-black"
              }`}
              style={activeIcon === "help" ? { color: uiColor } : {}}
            >
              Help
            </span>
          </button>
        )}
      </div>
    </div>
  );
}

export default Footer;
